import { ApolloError, useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import ms from 'ms.macro'
import { useMemo } from 'react'

import { CompetitionInfoQuery } from './__generated__/types-and-hooks'
import { apolloCompetitionClient } from './apollo'

const query = gql`
  query CompetitionInfo($competition: ID!) {
    tradingCompetition(id: $competition) {
      address
      competitionStart
      competitionEnd
      refereeMultiplier
      referrerPercent
      refereeMultiplierDuration
      refsCount
    }
  }
`

interface ICompetitionInfo {
  error?: ApolloError
  isLoading: boolean
  data: CompetitionInfoQuery
}
export default function useCompetitionInfo(): ICompetitionInfo {
  const {
    data,
    loading: isLoading,
    error,
  } = useQuery(query, {
    variables: { competition: '0' },
    client: apolloCompetitionClient,
    pollInterval: ms`15s`,
  })

  return useMemo(
    () => ({
      error,
      isLoading,
      data,
    }),
    [data, error, isLoading]
  )
}
